/* Soveria advertorial — runtime (v2.1.1)
   Loaded from theme assets via:
     <script src="{{ 'svr-advertorial.js' | asset_url }}" defer></script>
   Drives the reading-progress bar only — sticky mobile CTA is CSS-only,
   no JS needed for it after v2.1.
*/

(function () {
  var advRoot = document.querySelector('.svr-adv');
  if (!advRoot) return;

  /* ===== Reading-progress bar ===== */
  var progressFill = advRoot.querySelector('[data-svr-progress]');
  function updateProgress() {
    var rect = advRoot.getBoundingClientRect();
    var totalScroll = advRoot.offsetHeight - window.innerHeight;
    var scrolled = -rect.top;
    var pct = totalScroll > 0
      ? Math.max(0, Math.min(100, (scrolled / totalScroll) * 100))
      : 0;
    if (progressFill) progressFill.style.width = pct + '%';
  }

  window.addEventListener('scroll', updateProgress, { passive: true });
  window.addEventListener('resize', updateProgress);
  updateProgress();
})();